module.exports = __webpack_public_path__ + "static/media/percentage_icon.2ef1718c.svg";